import React from 'react';
import { Reveal, SplitText } from '../fx/Reveal';
type Props = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  as?: 'h1' | 'h2';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'center',
  as = 'h2'
}: Props) {
  const alignCls = align === 'center' ? 'items-center text-center mx-auto' : 'items-start text-left';
  return <div className={`flex max-w-2xl flex-col ${alignCls}`} data-id="element-367" data-mp="myy41hdoplao">
      {eyebrow && <Reveal data-id="element-368" data-mp="i7g50yv81usc">
          <span className="mb-4 inline-flex items-center gap-2 rounded-full border border-royal/20 bg-white/70 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-royal" data-id="element-369" data-mp="i7olf0qjzi8a">
            <span className="h-1.5 w-1.5 rounded-full bg-electric animate-pulse" data-id="element-370" data-mp="8aadjpip41rl" />
            {eyebrow}
          </span>
        </Reveal>}
      <SplitText as={as} text={title} className={`font-display text-3xl font-bold leading-[1.05] text-navy sm:text-4xl md:text-5xl ${align === 'center' ? 'text-center' : ''}`} data-id="element-371" data-mp="47dqnmm4hjhu" />
      {subtitle && <Reveal delay={0.15} data-id="element-372" data-mp="1ir9brn4ln8v7">
          <p className="mt-5 text-base leading-relaxed text-slate md:text-lg" data-id="element-373" data-mp="1irj2jcxgxk1y">
            {subtitle}
          </p>
        </Reveal>}
    </div>;
}